import { CorporatePartCostStatus } from 'corporate/enums';
import { Color } from 'theme/enums';
import { IColorMap } from 'theme/types';

import { PricingType } from '../enums';

export const statusColorMap: IColorMap = {
  [CorporatePartCostStatus.ACTIVE]: Color.SUCCESS,
  [CorporatePartCostStatus.EXPIRED]: Color.DANGER,
  [CorporatePartCostStatus.OLD]: Color.DANGER,
  [CorporatePartCostStatus.PENDING]: Color.WARNING,
};

export const pricingTypeLabelKey: Record<PricingType, string> = {
  [PricingType.CALCULATED]: 'labelCalculated',
  [PricingType.MANUAL]: 'labelManual',
};
